import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "encodeHTMLEntities",
    standalone: false
})
export class EncodeHTMLEntitiesPipe implements PipeTransform {
    // source: https://ourcodeworld.com/articles/read/188/encode-and-decode-html-entities-using-pure-javascript

    transform(value: string) {
        const buf: string[] = [];

        for (let i = value.length - 1; i >= 0; i--) {
            buf.unshift(["&#", value.charCodeAt(i), ";"].join(""));
        }

        return buf.join("");
    }
}
